/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DetachServerClientAssociationRequestBody,
  DetachServerClientAssociationRequestBody$Outbound,
  DetachServerClientAssociationRequestBody$outboundSchema,
} from "../components/detachserverclientassociationrequestbody.js";

export type DetachServerClientAssociationSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DetachServerClientAssociationSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DetachServerClientAssociationSecurity = {
  option1?: DetachServerClientAssociationSecurityOption1 | undefined;
  option2?: DetachServerClientAssociationSecurityOption2 | undefined;
};

export type DetachServerClientAssociationRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  detachServerClientAssociationRequestBody:
    DetachServerClientAssociationRequestBody;
};

/** @internal */
export type DetachServerClientAssociationSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DetachServerClientAssociationSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DetachServerClientAssociationSecurityOption1$Outbound,
    DetachServerClientAssociationSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function detachServerClientAssociationSecurityOption1ToJSON(
  detachServerClientAssociationSecurityOption1:
    DetachServerClientAssociationSecurityOption1,
): string {
  return JSON.stringify(
    DetachServerClientAssociationSecurityOption1$outboundSchema.parse(
      detachServerClientAssociationSecurityOption1,
    ),
  );
}

/** @internal */
export type DetachServerClientAssociationSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DetachServerClientAssociationSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DetachServerClientAssociationSecurityOption2$Outbound,
    DetachServerClientAssociationSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function detachServerClientAssociationSecurityOption2ToJSON(
  detachServerClientAssociationSecurityOption2:
    DetachServerClientAssociationSecurityOption2,
): string {
  return JSON.stringify(
    DetachServerClientAssociationSecurityOption2$outboundSchema.parse(
      detachServerClientAssociationSecurityOption2,
    ),
  );
}

/** @internal */
export type DetachServerClientAssociationSecurity$Outbound = {
  Option1?: DetachServerClientAssociationSecurityOption1$Outbound | undefined;
  Option2?: DetachServerClientAssociationSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DetachServerClientAssociationSecurity$outboundSchema:
  z.ZodMiniType<
    DetachServerClientAssociationSecurity$Outbound,
    DetachServerClientAssociationSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(
        z.lazy(() =>
          DetachServerClientAssociationSecurityOption1$outboundSchema
        ),
      ),
      option2: z.optional(
        z.lazy(() =>
          DetachServerClientAssociationSecurityOption2$outboundSchema
        ),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function detachServerClientAssociationSecurityToJSON(
  detachServerClientAssociationSecurity: DetachServerClientAssociationSecurity,
): string {
  return JSON.stringify(
    DetachServerClientAssociationSecurity$outboundSchema.parse(
      detachServerClientAssociationSecurity,
    ),
  );
}

/** @internal */
export type DetachServerClientAssociationRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DetachServerClientAssociationRequestBody:
    DetachServerClientAssociationRequestBody$Outbound;
};

/** @internal */
export const DetachServerClientAssociationRequest$outboundSchema: z.ZodMiniType<
  DetachServerClientAssociationRequest$Outbound,
  DetachServerClientAssociationRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    detachServerClientAssociationRequestBody:
      DetachServerClientAssociationRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      detachServerClientAssociationRequestBody:
        "DetachServerClientAssociationRequestBody",
    });
  }),
);

export function detachServerClientAssociationRequestToJSON(
  detachServerClientAssociationRequest: DetachServerClientAssociationRequest,
): string {
  return JSON.stringify(
    DetachServerClientAssociationRequest$outboundSchema.parse(
      detachServerClientAssociationRequest,
    ),
  );
}
